import amioWebappHttpClient from '@/services/amio-api/http/amio-webapp.http-client'
import { handleListResponse, handleError } from '@/services/amio-api/utils/request-utils'

class OrganizationService {
  constructor() {
    this.path = '/organizations'
  }

  list(ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .get(this.path)
      .then(handleListResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  get(ignoredHttpStatuses = []) {
    return this.list(ignoredHttpStatuses).then(({items}) => items[0])
  }
}

export default new OrganizationService()
